import { QUERY_TABLE_HEIGHT, parseQueryStatNumber } from "./queryBuilder";

export const RESULTS_GRID_SORTED_CLASS = "query-grid-sorted";
export const RESULTS_TABLE_HEIGHT = QUERY_TABLE_HEIGHT;
export const NAME_SORT_ORDER = ["asc", "desc"];
export const STAT_SORT_ORDER = ["desc", "asc"];

export const sortedClassFor = (field, sortedField) =>
  field === sortedField ? RESULTS_GRID_SORTED_CLASS : undefined;

export const getResultsGridSx = (height = RESULTS_TABLE_HEIGHT) => ({
  border: "none",
  height,
  "& .MuiDataGrid-row:hover": {
    bgcolor: "action.hover",
  },
  [`& .${RESULTS_GRID_SORTED_CLASS}`]: {
    fontWeight: 700,
    color: "primary.light",
  },
  [`& .MuiDataGrid-columnHeader.${RESULTS_GRID_SORTED_CLASS}`]: {
    color: "primary.main",
  },
});

export const formatGridStatValue = (value, format = "count") => {
  if (value == null || value === "") return "—";
  const num = parseQueryStatNumber(value);
  if (format === "rate") {
    if (num == null) return value;
    return num.toFixed(3).replace(/^0(?=\.)/, "");
  }
  if (format === "era" || format === "decimal2") {
    if (num == null) return value;
    return num.toFixed(2);
  }
  if (format === "percent") {
    if (num == null) return value;
    return `${Math.round(num * 100)}%`;
  }
  if (format === "seconds") {
    if (num == null) return value;
    return `${Math.round(num / 1000)}s`;
  }
  if (format === "year") {
    if (num == null) return value;
    return String(num);
  }
  return num == null ? value : num;
};
